module.exports = __webpack_public_path__ + "img/eagle.26fa5a85.png";